import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=229b077e&scoped=true"
import script from "./ShopView.vue?vue&type=script&lang=js"
export * from "./ShopView.vue?vue&type=script&lang=js"
import style0 from "@/css/shop.css?vue&type=style&index=0&id=229b077e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b077e",
  null
  
)

export default component.exports